import { useFieldApi } from '@data-driven-forms/react-form-renderer';
import { useEffect } from 'react';

import Button from './Button/Button';

type ToggleButtonProps = {
  name: string;
  label?: string;
  defaultValue?: boolean;
  on: any;
  off: any;
  sx?: any;
  type?: any;
  variant?: any;
  startIcon?: string;
  endIcon?: string;
  icon?: string;
  disabled?: boolean;
  onClick?: (...args: any[]) => any;
};

export default function ToggleButton(props: Readonly<ToggleButtonProps>) {
  const {
    name,
    label,
    on,
    off,
    defaultValue = false,
    type,
    variant,
    startIcon,
    endIcon,
    icon,
    disabled,
    sx,
    onClick,
  } = props;
  const {
    input: { value, onChange },
  } = useFieldApi(props);

  // eslint-disable-next-line @eslint-react/exhaustive-deps
  useEffect(() => onChange(defaultValue), []);

  const selectedProps = value ? on : off;

  const toPass = {
    name,
    label,
    type,
    variant,
    startIcon,
    endIcon,
    icon,
    ...selectedProps,
    sx: {
      ...(sx || {}),
      ...(selectedProps.sx || {}),
    },
    role: 'switch',
    ['aria-checked']: Boolean(value),
  };

  return (
    <Button
      onClick={(e) => {
        onChange(!value);
        onClick?.(e);
      }}
      disabled={disabled}
      {...toPass}
    />
  );
}
